import BooleanEditor from "./BooleanEditor.js";
import IntEditor from "./IntEditor.js";
import StringEditor from "./StringEditor.js";
import TimestampEditor from "./TimestampEditor.js";
import ComponentTypesEditor from "./ComponentTypesEditor.js";
import FotaItemSelector from "./fotaItemSelector/PluginSetup.js";
import FotaItemMultiSelector from "./fotaItemMultiSelector/PluginSetup.js";
import FirmwareComponentsSelector from "./firmwareComponentsSelector/PluginSetup.js";
import FotaAttrValueOptions from "./fotaAttrValueOptions/PluginSetup.js";
import DeviceGroupsSelector from "./deviceGroupsSelector/PluginSetup.js";
import StartTimeEditor from "./StartTimeEditor.js";
import EnumEditor from "./EnumEditor.js";
import LazyObjectEditor from "./LazyObjectEditor.js";
const install = molten => {
  molten.addPlugin('FotaAttributeEditor', BooleanEditor);
  molten.addPlugin('FotaAttributeEditor', IntEditor);
  molten.addPlugin('FotaAttributeEditor', StringEditor);
  molten.addPlugin('FotaAttributeEditor', TimestampEditor);
  molten.addPlugin('FotaAttributeEditor', LazyObjectEditor);
  molten.addPlugin('FotaAttributeEditor', ComponentTypesEditor);
  molten.addPlugin('FotaAttributeEditor', StartTimeEditor);
  molten.addPlugin('FotaAttributeEditor', EnumEditor);
  FotaItemSelector.install(molten);
  FotaAttrValueOptions.install(molten);
  FotaItemMultiSelector.install(molten);
  FirmwareComponentsSelector.install(molten);
  DeviceGroupsSelector.install(molten);
};
export { install };
export default {
  install
};